import { render, staticRenderFns } from "./purchaseConfirm.vue?vue&type=template&id=29244db8&scoped=true"
import script from "./purchaseConfirm.vue?vue&type=script&lang=js"
export * from "./purchaseConfirm.vue?vue&type=script&lang=js"
import style0 from "./purchaseConfirm.vue?vue&type=style&index=0&id=29244db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29244db8",
  null
  
)

export default component.exports